<template>
  <NuxtLayout>
    <div class="app_container w">
      <teacher-category-list
        :list="map.rankList"
        name="rankName"
        @change="changeRank"
      />
      <div v-loading="ctrl.loading">
        <new-teacher-list :list="map.teacherList" />
      </div>
      <div
        v-if="page.totalPage > 1"
        class="pagination"
      >
        <el-pagination
          v-model:currentPage="page.pageCurrent"
          :page-size="page.pageSize"
          background
          layout="total, prev, pager, next, jumper"
          :total="page.totalCount"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
import { teacherRankList, teacherPage } from '../../api/teacher.js'
import cookie from '@/utils/cookies'
const cookieData = cookie.getShop()
useHead({
  title: computed(() => `名师风采-${cookieData.shopName}`),
  meta: [{
    hid: 'keywords',
    name: 'keywords',
    content: '名师风采'
  },
  {
    hid: 'description',
    name: 'description',
    content: '名师风采'
  }]
})
const map = reactive({
  teacherList: [],
  rankList: [],
  rankId: '',
  introduce: ''
})
const page = reactive({
  totalCount: 0,
  pageCurrent: 1,
  pageSize: 15,
  totalPage: 1
})
const ctrl = reactive({
  loading: false
})
const router = useRouter()
const changeRank = (id) => {
  map.rankId = id
  getTeacherList()
}

const viewDetail = (i) => {
  router.push({
    path: '/tch/view',
    query: {
      id: i.id
    }
  })
}
const handleCurrentChange = (v) => {
  page.pageCurrent = v
  document.querySelector('#app').scrollTop = 0
  getTeacherList()
}

const getTeacherList = () => {
  ctrl.loading = true
  teacherPage({
    pageCurrent: page.pageCurrent,
    pageSize: page.pageSize,
    rankId: map.rankId
  }).then(res => {
    if (res) {
      map.teacherList = res.list || []
      page.pageCurrent = res.pageCurrent
      page.totalCount = res.totalCount
      page.totalPage = res.totalPage
      nextTick(() => {
        document.querySelectorAll('.intro').forEach((i, index) => {
          if (i.offsetHeight > 168) {
            map.teacherList[index].show = true
          }
        })
      })
    }
    ctrl.loading = false
  })
}
const { data, pending } = await useAsyncData('TeacherListPage', () => {
  return new Promise(async (resolve) => {
    Promise.allSettled([
      teacherRankList(),
      teacherPage({
        pageCurrent: page.pageCurrent,
        pageSize: page.pageSize,
        rankId: map.rankId
      })
    ]).then(([rank, teacher]) => {
      const data = {}
      if (rank.status === 'fulfilled') {
        data.rank = rank.value
      } else {
        data.rank = []
      }
      if (teacher.status === 'fulfilled') {
        data.teacher = teacher.value
      } else {
        data.teacher = []
      }
      resolve(data)
    })
  })
}, { initialCache: false })

if (!pending.value && data.value) {
  const d = data.value
  map.teacherList = d.teacher.list || []
  page.pageCurrent = d.teacher.pageCurrent
  page.totalCount = d.teacher.totalCount
  page.totalPage = d.teacher.totalPage
  map.rankList = [{ rankName: '全部', id: '' }].concat(d.rank || [])
}

</script>

<style lang="scss" scoped>
.content_page {
  width: 1200px;
  margin: 20px auto;
}
.pagination {
  text-align: center;
}
</style>
